import React from 'react';
import { Phone, Clock, Shield, Zap, AlertCircle } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../data/mock';

const Emergency = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`
      }}></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-red-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6 animate-pulse">
              <AlertCircle size={18} />
              <span>EMERGENCY SERVICE</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              24/7 Emergency Garage Door Repair
            </h2>
            <p className="text-xl text-blue-100">
              Garage door stuck? Won't open? We're here to help - day or night!
            </p>
          </div>

          {/* Features grid */}
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="flex items-center justify-center w-14 h-14 bg-green-500 rounded-full mb-4">
                <Clock size={28} />
              </div>
              <h3 className="text-xl font-bold mb-2">Fast Response</h3>
              <p className="text-blue-100">
                We arrive within 1-2 hours of your emergency call
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="flex items-center justify-center w-14 h-14 bg-green-500 rounded-full mb-4">
                <Zap size={28} />
              </div>
              <h3 className="text-xl font-bold mb-2">Available 24/7</h3>
              <p className="text-blue-100">
                Round-the-clock service, 365 days a year
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="flex items-center justify-center w-14 h-14 bg-green-500 rounded-full mb-4">
                <Shield size={28} />
              </div>
              <h3 className="text-xl font-bold mb-2">Expert Technicians</h3>
              <p className="text-blue-100">
                Licensed, insured professionals with years of experience
              </p>
            </div>
          </div>

          {/* CTA Box */}
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 text-center">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Need Emergency Service?
            </h3>
            <p className="text-xl text-gray-600 mb-8">
              Don't wait - call us now for immediate assistance
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
              <Button 
                onClick={() => window.location.href = `tel:${businessInfo.phone}`}
                size="lg"
                className="bg-red-600 hover:bg-red-700 text-white font-bold text-2xl px-12 py-8 shadow-xl hover:shadow-2xl transition-all w-full sm:w-auto"
              >
                <Phone size={28} className="mr-3" />
                {businessInfo.phone}
              </Button>
            </div>

            <p className="text-sm text-gray-500">
              Or scroll down to request a free quote for non-emergency services
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Emergency;
